import axios from "axios";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { useSearchParams } from "react-router-dom";
import FaqTable from "../inputComponents/FaqTable";

const VerifyFaqPrintout = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [searchParams, setSearchParams] = useSearchParams();

  const [allRecords, setAllRecords] = useState([]);
  const [general, setGeneral] = useState({
    salaryDate: null,
    referenceNo: null,
    stamp: 1,
    value: null,
  });

  // Encrypt Decrypt Data //
  const encrypt = (encrypDycrypData, type) => {
    let result;
    if (type === "Encrypt") {
      result = window.btoa(encrypDycrypData);
    } else if (type === "Decrypt") {
      result = window.atob(encrypDycrypData);
    }
    return result;
  };

  /* All records */
  useEffect(() => {
    (async () => await tableLoad())();

    if (searchParams.has("payload")) {
      const realValue = searchParams.get("payload");
      const decryptValues = encrypt(realValue, "Decrypt");

      setGeneral((prev) => ({
        ...prev,
        value: decryptValues,
      }));

      (async () => await tableLoad(general.value))();
    } else {
    }
  }, [searchParams, general.value]);

  async function tableLoad(values) {
    if (values) {
      console.log("###KKKK", values); //faqdata
      await axios.get(`sanctum/csrf-cookie`).then((response) => {
        try {
          axios
            .get(`${BASE_URL}verify/registrationpageverify${values}`)
            .then((res) => {
              if (res?.data?.status === 200) {
                if (res.data.allData.length === 0) {
                  swal(
                    "Oops!",
                    "Sorry! we did not find any information in the register",
                    "warning",
                  );
                } else {
                  setAllRecords(res.data.allData);

                  setGeneral((prev) => ({
                    ...prev,
                    salaryDate: res.data.StartDate + " to " + res.data.EndDate,
                  }));
                }
                console.log(res.data.bend);
              } else {
                console.log(res.data.validation_error);
              }
            });
        } catch (error) {
          swal("Error", "Error fetching Registry Data", "error");
          console.log("Error fetching Registry Data:", error);
        }
      });
    }
  }

  return (
    <>
      <div className="container">
        <FaqTable general={general} itemId={allRecords} />
      </div>
    </>
  );
};

export default VerifyFaqPrintout;
